module.exports = __webpack_public_path__ + "static/feature-label-values-81e0efaa32ed649102d491f02cc9c895.mp4";